import { createFileRoute, useParams } from "@tanstack/react-router"
import { Scoped } from "@/components/forms/students/UseStudentReviewStepper"
import { StudentReview } from "@/pages/students/StudentReview"
import { useMemo } from "react"
import {
  StudentReviewFormSteps,
  useStudentReviewStore,
} from "@/stores/useStudentReviewStore"

export const Route = createFileRoute(
  "/beheer/todo/$studentRegistrationId/controleren",
)({
  component: RouteComponent,
})

function RouteComponent() {
  const { studentRegistrationId } = useParams({
    from: "/beheer/todo/$studentRegistrationId/controleren",
  })
  const projectStepData = useStudentReviewStore((s) => s.projectStepData)

  const initialStep: StudentReviewFormSteps = useMemo(() => {
    if (projectStepData) return "personal"

    return "contract"
  }, [projectStepData])

  return (
    <Scoped initialStep={initialStep}>
      <StudentReview studentRegistrationId={studentRegistrationId} />
    </Scoped>
  )
}
